export enum Crossing {
  UP = 1,
  DOWN = 2,
}
